import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Table } from 'components';
import { Box, IconButton, Chip, Typography } from '@mui/material';
import { BsArrowDownCircle, BsFilter } from 'react-icons/bs';
import ApiServices from 'services';
import { getColumns } from './columns';
import { ContainerHeader, ButtonExport } from './styles';
import { CLIENT_STATUS_ID } from 'commons/constants';
import Utils from 'commons/utils';
import { Popup } from 'components';
import PopupUserSupervisor from './popups/popup-user-supervisor';

const START_DATE = moment().startOf('month').format();
const END_DATE = moment().endOf('date').format();

const DEFAULT_FILTER = {
  pageNumber: 1,
  pageSize: 10,
  fromDate: START_DATE,
  toDate: END_DATE,
};

function ClientsHolding() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [dataMainUserById, setDataMainUserById] = React.useState([]);
  const [clientCareHistoryItem, setClientCareHistoryItem] = React.useState({});


  const getListByPositionId = async (position, idClientCareHistory = '') => {
    try {
      const { data } = await ApiServices.getListByPositionId(position, idClientCareHistory);
      if (data && idClientCareHistory) {
        setDataMainUserById(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getClientCareHistoryDetails = async (idClientCareHistory) => {
    try {
      const { data } = await ApiServices.getClientCareHistoryDetails(idClientCareHistory);
      setClientCareHistoryItem(data);
      await getListByPositionId('admin', data.id);
    } catch (error) {
      console.error('Error fetching client details:', error);
    }
  };

  const initData = async (filter) => {
    setLoading(true);
    // await ApiServices.getClientCareHistoryByStatus(CLIENT_STATUS_ID.LEAD_HOLDING)
    await ApiServices.getClientCareHistoryByStatusWithPagin(CLIENT_STATUS_ID.LEAD_HOLDING, filter)
      .then((res) => {
        if (res?.data) {
          setData(res?.data?.data || []);
        }
      })
      .catch((err) => console.warn('initData - Client Sources', err));
    setLoading(false);
  };
  useEffect(() => {
    initData(filter);
  }, [filter]);

  useEffect(() => {
    initData(filter);
  }, [clientCareHistoryItem]);

  const handleSearchColumn = (event) => {
    setFilter((prev) => {
      const searchArray = { ...prev.searchArray };
      const { value, name } = event.target;
      if (!value) {
        delete searchArray[name];
        return { ...prev, pageNumber: 1, searchArray };
      }
      searchArray[name] = value;
      return { ...prev, pageNumber: 1, searchArray };
    });
  };

  const showPopUp = async (row) => {
    setSelected(row);
    await getClientCareHistoryDetails(row.id);
  };

  const handleRenegotiate = async (row) => {
    setLoading(true);
    await ApiServices.updateClientStatus(row?.id, CLIENT_STATUS_ID.CONFER_LEAD)
      .then((res) => {
        if (res?.data) {
          window.UIMessage?.success('Cập nhật thành công');
          initData(filter);
        }
      })
      .catch((err) => console.log('Delete Item holding', err));
    setLoading(false);
  };

  function typeClient(type) {
    switch (type) {
      case 'Kim Cương':
        return <Chip label="Kim Cương" sx={{ color: 'black', backgroundColor: '#00BFFF' }} />;
      case 'Bạch Kim':
        return <Chip label="Bạch Kim" sx={{ color: 'black', backgroundColor: '#66CDAA' }} />;
      case 'Bạc':
        return <Chip label="Bạc" sx={{ color: 'black', backgroundColor: '#C0C0C0' }} />;
      case 'Vàng':
        return <Chip label="Vàng" sx={{ color: 'black', backgroundColor: '#FFD700' }} />;

      default:
        return <Chip label="Mới" />;
    }
  }

  const handleExportClientHolding = async () => {
    setLoading(true);
    await ApiServices.exportExcel_TamNgung()
      .then((res) => {
        if (res?.data) {
          Utils.exportTemplate(
            res?.data,
            `DS_Khách_Hàng_Tạm_Ngưng_${Utils.formatSimpleDate(moment())}.xlsx`,
          );
        }
      })
      .catch((err) => {
        console.log('Export Client Company error:', err);
        window.UIMessage?.error('Tải thất bại !!!');
      });
    setLoading(false);
  };
  const renderHeader = () => (
    <>
      <ContainerHeader>
        <Typography variant="h6" component="h6" sx={{ m: '10px' }}>
          Danh Sách Khách Hàng Tạm Ngưng
        </Typography>
      </ContainerHeader>

      <IconButton aria-label="filter" sx={{ color: '#6C757D' }}>
        <BsFilter />
      </IconButton>
      <ButtonExport
        variant="outlined"
        startIcon={<BsArrowDownCircle />}
        onClick={handleExportClientHolding}
      >
        Tải excel
      </ButtonExport>
    </>
  );

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Table
          rows={data}
          headCells={getColumns(handleRenegotiate, typeClient, handleSearchColumn, showPopUp)}
          loading={loading}
          renderHeader={renderHeader}
        />
        <Popup
          title="Chọn phụ trách mới"
          open={Boolean(selected?.id)}
          closePopup={() => setSelected(false)}
          body={
            <PopupUserSupervisor
              clientCareHistoryItem={clientCareHistoryItem}
              getClientCareHistoryDetails={getClientCareHistoryDetails}
              dataMainUserById={dataMainUserById}
              setDataMainUserById={setDataMainUserById}
            />
          }
        />
      </Box>
    </>
  );
}
export { ClientsHolding };
